export default {
  baseUrl: 'https://calmos.myapps.biorius.com/api',
  notificatorUrl: 'https://api.calmos.myapps.biorius.com:8000',
};
